import { useDictionary } from './useDictionary';
import type { TransferInternalSettingsDictionary } from '@/shared/types';

const useTransferInternalSettingsDictionary = () => {
  const { data, isLoading, isError } =
    useDictionary<TransferInternalSettingsDictionary>({
      dictionaryName: 'transferinternalsettings',
    });

  return {
    transferInternalSettingsData: data,
    isTransferInternalSettingsLoading: isLoading,
    isTransferInternalSettingsError: isError,
  };
};

export { useTransferInternalSettingsDictionary };
